import AbstractRequestTask from "../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class CertificateTask extends AbstractRequestTask {

  constructor(url, params) {
    super();
    this._url = url ;
    this._params = params || {}
  }

  getMethod() {
    return 'GET';
  }

  getHeaders() {
    return {  };
  }

  getUrl() {
    return this._url;
  }

  getParams() {
    const params = super.getParams();
    return this._params;
  }

  getResponseType(){
    return "arraybuffer";
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {  
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default CertificateTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/video/CertificateTask.js